module.exports = __webpack_public_path__ + "img/img_article4_deer@2x.e8c98f4b.png";